export default "__VITE_ASSET__CYgTQYzW__"